import { DownOutlined } from "@ant-design/icons";
import { Tree } from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { rutaSetActive } from "../../../actions/usuario";

const fn_LoadChildren = ({ allRutas = [], patternId }) => {
  let opts = [];
  const childrens = allRutas?.filter((x) => x.rutapadre === patternId);
  childrens.forEach((row) => {
    let objRuta = {
      title: row?.nombre,
      key: row?.id,
      isLeaf: row?.eslink,
      data: row,
    };
    const childs = allRutas?.filter((x) => x.rutapadre === row?.id);
    if (childs.length > 0) {
      let objRutaChild = fn_LoadChildren({ allRutas, patternId: row?.id });
      objRuta = { ...objRuta, children: objRutaChild };
    }
    opts = [...opts, objRuta];
  });
  return opts;
};
const getAllKeys = (data) => {
  return (
    data?.flatMap((record) => [
      record.key,
      ...(record.children ? getAllKeys(record.children) : []),
    ]) || []
  );
};

export const RutaTree = ({ rutas, keysSelected, handleTreeNodeSelected }) => {
  const [data, setData] = useState([]);
  const [keysExpanded, setKeysExpanded] = useState([]);

  const dispatch = useDispatch();
  useEffect(() => {
    const datos = fn_LoadChildren({ allRutas: rutas, patternId: null });
    const allKeys = getAllKeys(datos);
    setKeysExpanded(allKeys);
    setData(datos);
  }, [rutas]);

  const handleSelect = (keys, info) => {
    dispatch(rutaSetActive(info?.node?.data));
    handleTreeNodeSelected(keys);
  };
  return (
    <Tree.DirectoryTree
      treeData={data}
      showLine
      switcherIcon={<DownOutlined />}
      expandedKeys={keysExpanded}
      selectedKeys={keysSelected}
      selectable={true}
      onSelect={handleSelect}
    />
  );
};
